import { moment } from '@LIBS';
import { Constants } from '@CONFIG';

const useLogics = () => {
  const columns = [
    {
      title: 'Tarih',
      key: 'transactionTime',
      dataIndex: 'transactionTime',
      width: 200,
      render: (data, record) =>
        moment(record.transactionDateTime).format(
          Constants.FORMATS.dateTimeFormat
        ),
    },
    {
      title: 'Durum',
      key: 'transaction',
      dataIndex: 'transaction',
    },
  ];

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
